// extracted by mini-css-extract-plugin
export default {"content":"RequestAbout_content__p4yu0","grid":"RequestAbout_grid__T8f22","column":"RequestAbout_column__tbcIC"};